import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faDownload,
  faFileDownload,
  faTimes,
  faArrowLeft,
  faSearch,
  faHome,
  faThumbsUp,
  faThumbsDown,
  faUser,
  faUserCircle,
  faComment,
  faEye,
  faCalendarWeek,
  faChevronUp,
  faChevronDown,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

export default library.add(
  faDownload,
  faFileDownload,
  faTimes,
  faArrowLeft,
  faSearch,
  faHome,
  faThumbsUp,
  faThumbsDown,
  faUser,
  faUserCircle,
  faComment,
  faEye,
  faCalendarWeek,
  faChevronUp,
  faChevronDown,
  faSpinner
);
